import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { useLang } from "../../i18n";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;
const empty = { name: "", company: "", business_type: "", email: "", phone: "", message: "", privacy: false, marketing: false };

export const ContactForm = () => {
  const { t } = useLang();
  const [f, setF] = useState(empty);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const types = [t("cf.type1"), t("cf.type2"), t("cf.type3"), t("cf.type4"), t("cf.type5"), t("cf.type6")];

  const submit = async (e) => {
    e.preventDefault();
    if (!f.privacy) return toast.error("Devi accettare l'informativa sulla privacy.");
    if (!API) return toast.error("Servizio non disponibile al momento.");
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, f);
      toast.success("Richiesta inviata. Ti risponderemo al più presto.");
      setF(empty);
    } catch (err) {
      toast.error("Invio non riuscito. Controlla i dati e riprova.");
    } finally {
      setLoading(false);
    }
  };

  const Field = ({ label, id, ...rest }) => (
    <label className="block">
      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#57534E]">{label}</span>
      <input id={id} data-testid={`contact-input-${id}`} className="field" {...rest} />
    </label>
  );

  return (
    <form onSubmit={submit} data-testid="contact-form" className="bg-[#FFFFFF] border border-[#E6DFD3] p-6 sm:p-10 lg:p-14 space-y-8">
      <div className="grid sm:grid-cols-2 gap-8">
        <Field label={t("cf.name")} id="name" required minLength={2} value={f.name} onChange={set("name")} />
        <Field label={t("cf.company")} id="company" value={f.company} onChange={set("company")} />
        <Field label={t("cf.email")} id="email" type="email" required value={f.email} onChange={set("email")} />
        <Field label={t("cf.phone")} id="phone" value={f.phone} onChange={set("phone")} />
        <label className="block">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#57534E]">{t("cf.type")}</span>
          <select data-testid="contact-select-business-type" required className="field bg-transparent" value={f.business_type} onChange={set("business_type")}>
            <option value="">{t("cf.select")}</option>
            {types.map((tp) => <option key={tp} value={tp}>{tp}</option>)}
          </select>
        </label>
      </div>
      <label className="block">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#57534E]">{t("cf.msg")}</span>
        <textarea data-testid="contact-input-message" required minLength={5} rows={4} className="field resize-none" value={f.message} onChange={set("message")} />
      </label>
      <div className="space-y-4 text-sm text-[#57534E] leading-snug">
        <label className="flex gap-3 items-start cursor-pointer">
          <input type="checkbox" data-testid="contact-privacy-checkbox" className="mt-1 accent-[#9A4930] w-4 h-4" checked={f.privacy} onChange={set("privacy")} />
          <span>{t("cf.privacy_a")}<Link to="/privacy" data-testid="contact-privacy-link" className="underline underline-offset-2 hover:text-[#9A4930] whitespace-nowrap">{t("cf.privacy_link")}</Link>{t("cf.privacy_b")}</span>
        </label>
        <label className="flex gap-3 items-start cursor-pointer">
          <input type="checkbox" data-testid="contact-marketing-checkbox" className="mt-1 accent-[#9A4930] w-4 h-4" checked={f.marketing} onChange={set("marketing")} />
          <span>{t("cf.marketing")}</span>
        </label>
      </div>
      <p className="text-sm text-[#57534E] leading-relaxed border-l-2 border-[#C18A53] pl-4" data-testid="contact-microcopy">{t("cf.micro")}</p>
      <button type="submit" disabled={loading} data-testid="contact-submit-button" className="btn-pill bg-[#29221D] text-[#FBF9F5] disabled:opacity-60">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
        {t("cf.send")} <ArrowRight className="w-4 h-4" />
      </button>
    </form>
  );
};
